import * as service from './service';

export const testCentreOverviewStore = {
  service,
};
